// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__sBlYe","imageBonusWrap":"styles_imageBonusWrap__yqpSE","image":"styles_image__EZ1tq"};